import {NgClass} from '@angular/common';
import {booleanAttribute, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef} from '@angular/core';

import {SimpleLibelleComponent} from '../simple-libelle/simple-libelle.component';
import {FonteIconeComponent} from '../fonte-icone/fonte-icone.component';

//Composant boîte de dialogue générique
@Component (
{
  selector: 'val-boite-dialogue-generique',
  imports: 
  [
    NgClass,
    SimpleLibelleComponent,
    FonteIconeComponent
  ],
  templateUrl: './boite-dialogue-generique.component.html',
  styleUrl: './boite-dialogue-generique.component.scss'
})
export class BoiteDialogueGeneriqueComponent<T> 
{
  //Création
  constructor () 
  {
    this.validerVisible = true;
    this.annulerVisible = true;
    this.validerDesactive = false;
    this.annulerDesactive = false;
    this.validerClick = new EventEmitter<void> ();
    this.annulerClick = new EventEmitter<void> ();
  }

  //Boîte de dialogue
  @ViewChild ("dialogueGenerique")
  public dialogueGenerique!: ElementRef;

  //Titre de la boite de dialogue
  @Input ()
  public titre!: string;

  //Indique si le bouton valider est visible
  @Input ({transform: booleanAttribute})
  public validerVisible: boolean;

  //Indique si le bouton annuler est visible
  @Input ({transform: booleanAttribute})
  public annulerVisible: boolean;
  
  //Indique si le bouton valider est désactivé
  @Input ({transform: booleanAttribute})
  public validerDesactive: boolean;
  
  //Indique si le bouton annuler est désactivé
  @Input ({transform: booleanAttribute})
  public annulerDesactive: boolean;

  //Evénement valider
  @Output ()
  public validerClick: EventEmitter<void>;

  //Evénement annuler
  @Output ()
  public annulerClick: EventEmitter<void>;

  //Fonction de retour
  public fonctionRetour!: (retourDialogue: T) => void;

  //Ouvre la boîte de dialogue
  //  Retourne
  //    Données de retour
  public async Ouvrir () : Promise<T> 
  {
    let operation: Promise<T>;

    this.dialogueGenerique.nativeElement.showModal ();

    operation = new Promise<T> ((fonctionRetour) =>
    {
      this.fonctionRetour = fonctionRetour;
    });

    return operation;
  }

  //Ferme la boite de dialogue
  public Fermer () : void 
  {
    this.dialogueGenerique.nativeElement.close ();
  }

  //Indique si la boîte de dialogue est ouverte
  //  Retourne
  //    Vrai si la boite de dialogue est ouverte
  public Ouverte () : boolean 
  {
    return this.dialogueGenerique.nativeElement.open;
  }

  //Envoie l’évènement valider
  public EnvoyerValider () : void 
  {
    this.validerClick.emit ();
  }

  //Envoie l’évènement annuler
  public EnvoyerAnnuler () : void 
  {
    this.annulerClick.emit ();
  }
}
